












































    import { Vue, Component, Prop } from "../../Infrastructure/CorBase/CoreBase";  

				@Component
				export default class BaseTLModalDialog extends Vue {   

					@Prop({ type: String, required: true, default: "" }) id!: "";
					@Prop({ type: String, required: true, default: null }) title?: string;
                    @Prop({ type: String, required: false, default: '' }) classModal?: string;
					@Prop({ type: String, required: false, default: '' }) content?: string;
					@Prop({ type: Boolean, required: false, default: true }) okOnly?: boolean; // když je false tak je Ano a Ne
                    @Prop({ type: Boolean, required: false, default: true }) centred?: boolean; 
					@Prop({ type: String, required: false, default: 'Ok'  }) okButtonTitle!: string;
					@Prop({ type: String, required: false, default:  'baseModalDialogSimple.answerNo' }) cancelButtonTitle!: string;				

					// VaPTODO - itemId je zde zbytecne
					onClickOk() {
						this.$bvModal.hide(this.id);
						this.$emit('clickOK');
					};		

					modelClass() {
						if (this.classModal != "") {
							return "dialogSimpleHeader dialogSimpleFooter dialogSimpleAllModal " + this.classModal;
						}
						else {
							return "dialogSimpleHeader dialogSimpleFooter dialogSimpleAllModal dialogSimpleBody";
						}
					}


					goBack(item: any) {
						this.$emit('goBack', item);
						this.$bvModal.hide(this.id);
					}
	}

